export default __webpack_public_path__ + "images/VP.7c276f7.png";